const successUrl = new URL(`${window.location.origin}/success`);
const failUrl = new URL(`${window.location.origin}/fail`);

export async function startFullPayment(orderData) {
    const payments = new cp.CloudPayments({
        language: "ru-RU",
        email: orderData.email,
        applePaySupport: true,
        googlePaySupport: true,
        yandexPaySupport: true,
        tinkoffPaySupport: true,
        tinkoffInstallmentSupport: false,
        sbpSupport: true,
    });

    try {
        const result = await payments.pay(
            "charge",
            {
                publicId: process.env.MIX_PAYMENT_ID,
                invoiceId: orderData.id,
                description: "Полная оплата курса",
                amount: orderData.full_price,
                currency: "RUB",
                email: orderData.email,
                skin: "classic",
                requireEmail: true,
            },
            {
                onSuccess: () => {
                    window.location.href = successUrl.href;
                },
            }
        );
        console.log("result", result);
    } catch (error) {
        window.location.href = failUrl.href;
        console.log("error", error);
    }
}

// export async function startInstallmentPayment(orderData) {
//     const terminalConfiguration = await cp.sdk.getTerminalConfiguration({
//         publicId: process.env.MIX_PAYMENT_ID,
//     });

//     const payment = await cp.sdk.getPayment({
//         amount: orderData.installment_price,
//         currency: "RUB",
//         description: "Оплата в рассрочку",
//     });

//     //Проверка доступности продукта Тинькофф Кредитование на терминале
//     if (
//         !terminalConfiguration.isPaymentMethodEnabled(
//             cp.sdk.constants.PaymentMethods.TCSCredit
//         )
//     ) {
//         localStorage.setItem('payments-link', window.location.href)
//         window.location.href = failUrl.href;
//         return; //В случае недоступности прерываем процесс
//     }

//     const tcsCredit = new cp.sdk.TCSCredit(terminalConfiguration);

//     //Конфигурация
//     const options = {
//         orderNumber: "",
//         values: {
//             contact: {
//                 email: orderData.email,
//             },
//         },
//         items: [
//             {
//                 name: "Курс «Профессия Веб-разработчик на фрилансе»",
//                 quantity: 1,
//                 price: orderData.installment_price,
//             },
//         ],
//     };

//     //Запуск окна
//     try {
//         const result = await tcsCredit.start(payment, options);
//         let isSuccess

//         //Обработка статуса заявки
//         //Здесь возможны события SUCCESS, APPOINTED, REJECT, CANCEL, ERROR_RESUME, MODAL_CLOSED
//         switch (result.status) {
//             case cp.sdk.constants.TCSCredit.Status.SUCCESS:
//                 // console.log("Успешное оформление");
//                 isSuccess = true;
//                 break;
//             // case cp.sdk.constants.TCSCredit.Status.APPOINTED:
//             //     console.log("Назначена встреча");
//             //     break;
//             case cp.sdk.constants.TCSCredit.Status.APPROVED:
//                 // console.log("Заявка одобрена");
//                 isSuccess = true;
//                 break;
//             case cp.sdk.constants.TCSCredit.Status.REJECT:
//                 // console.log("Заявка отклонена");
//                 isSuccess = false;
//                 break;
//             // case cp.sdk.constants.TCSCredit.Status.CANCEL:
//             //     console.log("Пользователь отменил заявку");
//             //     break;
//             case cp.sdk.constants.TCSCredit.Status.ERROR_RESUME:
//                 // console.log("Произошла ошибка");
//                 isSuccess = false;
//                 break;
//             // case cp.sdk.constants.TCSCredit.Status.MODAL_CLOSED:
//             //     console.log("Закрыто окно заявки");
//             //     break;
//             // default:
//             //     console.log("Получен статус: " + result.status);
//             //     break;
//         }

//         const installmentModal = document.querySelector(".modal-root--DIM5T");

//         installmentModal?.addEventListener('click', (e) => {
//             const target = e.target.closest('[class^="modal-content"]')

//             if (target) return

//             if (isSuccess) {
//                 window.location.href = successUrl.href;
//             } else if (isSuccess === false) {
//                 localStorage.setItem('payments-link', window.location.href)
//                 window.location.href = failUrl.href;
//             }
//         })
//     } catch (error) {
//         window.location.href = failUrl.href;
//         console.log(error);
//     }
// }
